import { useLanguage } from "@/contexts/LanguageContext";
import { Link } from "react-router-dom";

const content = {
  sv: {
    title: "Om Diamond Domes",
    leadStatement: "Från magiska trädgårdsrum till framtidens cirkulära boenden – här finns marknadens alla guldkorn.",
    mainStatement: "Vi tillverkar och levererar kupoler anpassade för nordiskt klimat och året runt-bruk, vi samarbetar även med internationellt ledande domebyggare och arkitekter.",
    description: "Vi är baserade i Molkom, Värmland, och levererar i hela Sverige — till privatpersoner, hotell, campingar och destinationer inom besöksnäringen.",
    cta: "Läs mer om oss"
  },
  en: {
    title: "About Diamond Domes",
    leadStatement: "From magical garden rooms to the circular homes of the future – here you will find all the gems of the market.",
    mainStatement: "We manufacture and deliver domes adapted for the Nordic climate and year-round use, and we collaborate with internationally leading dome builders and architects.",
    description: "We are based in Molkom, Värmland, and deliver across Sweden — to private customers, hotels, campsites and destinations within the hospitality industry.",
    cta: "Learn more about us"
  },
  de: {
    title: "Über Diamond Domes",
    leadStatement: "Von magischen Gartenräumen bis zu den zirkulären Wohnungen der Zukunft – hier finden Sie alle Schätze des Marktes.",
    mainStatement: "Wir fertigen und liefern Kuppeln, die an das nordische Klima und die ganzjährige Nutzung angepasst sind, und arbeiten mit international führenden Kuppelbauern und Architekten zusammen.",
    description: "Wir haben unseren Sitz in Molkom, Värmland, und liefern in ganz Schweden — an Privatkunden, Hotels, Campingplätze und Destinationen der Tourismusbranche.",
    cta: "Mehr über uns erfahren"
  }
};

export const AboutSection = () => {
  const { language } = useLanguage();
  const t = content[language];

  return (
    <section id="about" className="py-20 px-4 md:px-6 bg-background">
      <div className="container mx-auto">
        <article className="animate-slide-up text-center">
          {/* Sektions-rubrik (semantisk H2 för SEO) */}
          <h2 className="sr-only">{t.title}</h2>

          {/* Lead statement - Hero-style med grön box (visuellt oförändrad) */}
          <p className="text-xl md:text-2xl lg:text-3xl font-serif font-bold text-foreground mb-8 leading-tight bg-primary/10 p-4 md:p-6 rounded-lg border-l-4 border-primary">
            {t.leadStatement}
          </p>
          
          <div className="space-y-4 text-lg leading-relaxed text-muted-foreground max-w-3xl mx-auto">
            <p className="text-foreground">
              {t.mainStatement}
            </p>
            
            <p>
              {t.description}
            </p>
            
            <div className="pt-4">
              <Link 
                to="/about" 
                className="inline-flex items-center text-primary hover:text-primary/80 font-medium transition-smooth"
              >
                {t.cta} →
              </Link>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
};
